import { IPermissionRole, IPermission, IUserRole } from '../../types/types';
import { graphQLPost } from '../../utilities';

export default class PermissionRole {

    static async getPermissionRoles(): Promise<IPermissionRole[]> {

        const permissionRoles = await graphQLPost('{ roles { id name description system } }');
        
        return permissionRoles.roles as IPermissionRole[];
    }

    static async getPermissionRole(id: number): Promise<IPermissionRole> {

        try {
            const permissionRole 
                    = await graphQLPost(
                        `query GetRole($roleId: Int) { 
                            role(id: $roleId) { 
                                id name description system
                                userRole { id user { id } }
                                permissions { id fieldName fieldValue permissionTypeId }
                            } 
                        }`,
                        { roleId: id }
                    );
    
            return permissionRole.role as IPermissionRole;
        }
        catch (e) {
            console.error(e);
            throw("Ett problem uppstod vid försök att hämta behörighetsgrupp");
        }
    }

    static async addPermissionRole(role: IPermissionRole): Promise<IPermissionRole> {
        try {
            const permissionRole 
                    = await graphQLPost(
                        `mutation AddRole($role: RoleInputType!) { 
                            addRole(role: $role) { id name description } 
                        }`,
                        { role: { name: role.name, description: role.description } }
                    );
    
            return permissionRole.addRole as IPermissionRole;
        }
        catch (error) {
            console.error(error);

            throw("Fel vid skapandet utav behörighetsgrupp...");
        }
    }

    static async updatePermissionRole(role: IPermissionRole): Promise<IPermissionRole> {
        try {
            const permissionRole 
                    = await graphQLPost(
                        `mutation SetRole($role: RoleInputType!) { 
                            setRole(role: $role) { id name description } 
                        }`,
                        { role: { id: role.id, name: role.name, description: role.description } }
                    );

            return permissionRole.setRole as IPermissionRole;
        }
        catch (error) {
            throw("Fel vid sparning utav behörighetsgrupp...")
        }
    }

    static async deletePermissionRole(role: IPermissionRole): Promise<IPermissionRole> {
        try {
            const permissionRole 
                    = await graphQLPost(
                        `mutation DeleteRole($id: Int!) { 
                            deleteRole(id: $id) { id name }
                        }`,
                        { id: role.id }
                    );
    
            return permissionRole.addRole as IPermissionRole;
        }
        catch (error) {
            console.error(error);

            throw("Fel vid borttagning av behörighetsroll...");
        }
    }

    static async addUserRole(PermissionRoleId: number, UserId: number): Promise<number> {
        try {
            const userRole 
                    = await graphQLPost(
                        `mutation AddUserRole($userRole: UserRoleInputType!) { 
                            addUserRole(userRole: $userRole) { id }
                        }`,
                        { userRole: { roleId: PermissionRoleId, userId: UserId } }
                    );
    
            return userRole.addUserRole.id as number;
        }
        catch (error) {
            console.error(error);

            throw("Fel vid tillägg av användare...");
        }
    }
    
    static async deleteUserRole(userRoleId: number) {
        try {
            const permissionRole 
                    = await graphQLPost(
                        `mutation DeleteUserRole($id: Int!) { 
                            deleteUserRole(id: $id) { id }
                        }`,
                        { id: userRoleId }
                    );
    
            return true;
        }
        catch (error) {
            console.error(error);

            throw("Fel vid tillägg av användare...");
        }
    }

    static async addPermissions(roleId: number, permissions: IPermission[]): Promise<IPermission[]> {
        const permissionInputObj = permissions.map(p => ({
            roleId,
            fieldName: p.fieldName,
            fieldValue: p.fieldValue,
            permissionTypeId: p.permissionTypeId
        }));

        try {
            const resPermissions
                    = await graphQLPost(
                        `mutation AddPermissions($permissions: [PermissionInputType]!) {
                            addPermissions(permissions: $permissions) { id fieldName fieldValue permissionTypeId }
                        }`,
                        { permissions: permissionInputObj }
                    );
            return resPermissions.addPermissions as IPermission[]
        }
        catch (error) {
            throw("Fel vid sparning av rättigheter...")
        }
    }

    static async deletePermission(permissionId: number) {
        try {
            const resPermission
                    = await graphQLPost(
                        `mutation DeletePermission($id: Int!) {
                            deletePermission(id: $id) { id fieldName fieldValue permissionTypeId }
                        }`,
                        { id: permissionId }
                    );

            return resPermission.deletePermisison as IPermission;
        }
        catch (error) {
            console.error({error});
            throw("Fel vid borttagning av rättighet...");
        }
    }
}